import {
  IDocumentMediaPreviewData,
  IMessage,
  IStarredMessageTypeData,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { List } from "@mui/material";
import EmptyRecordView from "../../common/EmptyRecordView";
import GoToTop from "../../common/GoToTop";
import ScrollListContainer from "../../common/ScrollListContainer";
import { useScrollAnchor } from "../../hooks/useScrollAnchor";
import StarredMessageListItem from "./StarredMessageListItem";
import { useContext } from "react";
import { DocumentMediaViewerContext } from "../../context/DocumentMediaViewerContext";

interface StarredMessageListType {
  starredMessageTypeData: IStarredMessageTypeData[];
  onScroll?: () => Promise<void>;
  isDataLoading?: boolean;
}

export const StarredMessageList = ({
  starredMessageTypeData,
  onScroll,
  isDataLoading,
}: StarredMessageListType) => {
  const { openDocumentMediaViewer } = useContext(DocumentMediaViewerContext);

  const { scrollContainerRef, isShowGoToTopButton, goToTop } = useScrollAnchor({
    items: starredMessageTypeData,
    getItemId: item => item.message?.getMessage().id || "",
    disableScrollCompensation: true,
  });

  const openMediaDialog = (message: IMessage) => {
    const previewMedia = message.getPreviewDataFromMessage();
    const messagesWithImageContent = starredMessageTypeData.filter(
      (starredMessage: IStarredMessageTypeData) => {
        return (
          starredMessage.message?.getMessage().contentType ===
          MESSAGE_CONTENT_TYPE.IMAGE
        );
      },
    );
    const previewMediaList: IDocumentMediaPreviewData[] =
      messagesWithImageContent.map(starredMessage => {
        return starredMessage.message?.getPreviewDataFromMessage() as IDocumentMediaPreviewData;
      });
    openDocumentMediaViewer(
      previewMedia as IDocumentMediaPreviewData,
      previewMediaList,
    );
  };

  return (
    <ScrollListContainer
      ref={scrollContainerRef}
      dataTestId={"starred-message-list-container"}
      onScrollCallback={onScroll}
      isLoading={isDataLoading}
      restTop={165}
    >
      <>
        {isShowGoToTopButton && <GoToTop onClick={goToTop} />}
        {starredMessageTypeData.length > 0 ? (
          <List data-testid="starred-message-list">
            {starredMessageTypeData.map((data: IStarredMessageTypeData) => {
              const messageId = data.message?.getMessage().id;
              return (
                <StarredMessageListItem
                  data={data}
                  key={messageId}
                  openMediaDialog={openMediaDialog}
                />
              );
            })}
          </List>
        ) : (
          <EmptyRecordView />
        )}
      </>
    </ScrollListContainer>
  );
};
